import * as React from 'react';
import { getBasePath } from '../../utils/browser';

// FIXME: ToolIconButtonのコピペ実装

interface ToggleIconButtonProps {
  readonly onClick?: (isOn: boolean) => void;
  readonly iconNameOff: string;
  readonly iconNameOn: string;
  readonly isOn: boolean;
  readonly className?: string;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly margin?: boolean;
}

interface ToggleIconButtonState {
  isOn: boolean;
}

class ToggleIconButton extends React.PureComponent<ToggleIconButtonProps, ToggleIconButtonState> {
  private readonly baseDir: string;

  public constructor(props: ToggleIconButtonProps) {
    super(props);

    this.state = { isOn: props.isOn };

    this.baseDir = getBasePath();
  }

  private handleOnClick = () => {
    if (this.props.disabled) {
      return;
    }

    const newState = !this.state.isOn;
    this.setState({ isOn: newState });

    if (this.props.onClick != null) {
      this.props.onClick(newState);
    }
  }

  public componentWillReceiveProps(nextProps: Readonly<ToggleIconButtonProps>) {
    this.setState({ isOn: nextProps.isOn });
  }

  public render() {
    const iconButtonStyle: React.CSSProperties = {
      width: '48px',
      height: '48px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'inherit',
      textDecoration: 'none',
      background: 'rgba(0, 0, 0, 0.1)',
      boxSizing: 'border-box',
    };

    const { props } = this;

    if (props.margin !== false) {
      iconButtonStyle.margin = '8px';
    }
    if (props.active) {
      iconButtonStyle.border = '2px solid white';
    }
    if (props.disabled) {
      iconButtonStyle.filter = 'brightness(0.5)';
    }

    const imgSrc = this.state.isOn
      ? `${this.baseDir}/images/tool-icons/${props.iconNameOn}.png`
      : `${this.baseDir}/images/tool-icons/${props.iconNameOff}.png`;

    return (
      <a
        style={{ ...iconButtonStyle, ...props.style }}
        href={props.href}
        onClick={this.handleOnClick}
        title={props.title}
        aria-label={props.ariaLabel}
        className={`material-icons ${props.className}`}>
        <img src={imgSrc} style={{ maxWidth: '48px', maxHeight: '48px' }} />
      </a>
    );
  }
}

export default ToggleIconButton;
